/**
 * Internal dependencies.
 */
import blockJson from './block.json';

/**
 * Block constants
 */
const { name } = blockJson;

const layouts = [ {
	name: 'layout-1',
	label: 'Layout 1',
	imageAlign: 'center',
	titleAlign: 'center',
	ratingAlign: 'center',
	thumbnailUrl: `${ window._gutenify.plugin_directory_url }/assets/images/post-slider-layouts/layout-1.png`,
}, {
	name: 'layout-2',
	label: 'Layout 2',
	imageAlign: 'center',
	titleAlign: 'left',
	ratingAlign: 'left',
	thumbnailUrl: `${ window._gutenify.plugin_directory_url }/assets/images/post-slider-layouts/layout-2.png`,
}, {
	name: 'layout-3',
	label: 'Layout 3',
	imageAlign: 'center',
	titleAlign: 'right',
	ratingAlign: 'right',
	thumbnailUrl: `${ window._gutenify.plugin_directory_url }/assets/images/post-slider-layouts/layout-3.png`,
}, {
	name: 'layout-4',
	label: 'Layout 4',
	imageAlign: 'center',
	titleAlign: 'right',
	ratingAlign: 'right',
	thumbnailUrl: `${ window._gutenify.plugin_directory_url }/assets/images/post-slider-layouts/layout-4.png`,
}, {
	name: 'layout-5',
	label: 'Layout 5',
	imageAlign: 'center',
	titleAlign: 'right',
	ratingAlign: 'right',
	thumbnailUrl: `${ window._gutenify.plugin_directory_url }/assets/images/post-slider-layouts/layout-5.png`,
} ];

const hookPrefix = name.replace( '/', '-' );
export default {
	hookPrefix,
	layouts,
};
